import {ErrorGlobalResponseInterface} from '@/types/types'

type ApiResponse<T> = T | ErrorGlobalResponseInterface

export function isErrorResponse<T>(
  response: ApiResponse<T>
): response is ErrorGlobalResponseInterface {
  return (response as ErrorGlobalResponseInterface).error
}
